export default __webpack_public_path__ + "apply6f98122.png";